import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { homeMedia } from '../../../config/homeMedia';

const heroImage = homeMedia.heroMedia || 'https://images.unsplash.com/photo-1531482615713-2afd69097998?auto=format&fit=crop&w=1600&q=80';

export default function Hero() {
  const scrollToGuide = (e) => {
    e.preventDefault();
    const guideSection = document.getElementById('the-guide');
    if (guideSection) {
      const headerOffset = 80;
      const elementPosition = guideSection.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section className="relative w-full min-h-[720px] h-[85vh] flex items-center mt-[80px] overflow-hidden bg-[#050506]">
      {/* Background Media with Multi-Stage Gradient Overlay */}
      <div 
        className="absolute inset-0 z-0"
        style={{
          backgroundImage: `linear-gradient(
            90deg,
            rgba(3, 5, 9, 0.98) 0%,
            rgba(3, 5, 9, 0.88) 34%,
            rgba(3, 5, 9, 0.45) 66%,
            rgba(3, 5, 9, 0.18) 100%
          ), url(${heroImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center right',
          backgroundRepeat: 'no-repeat',
          backgroundColor: '#050506'
        }}
        aria-label="Maxmark strategists analysing market and advertising intelligence."
        role="img"
      ></div>

      <div className="relative z-10 w-[calc(100%-40px)] md:w-[calc(100%-64px)] max-w-[1200px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="max-w-[720px] py-[80px]"
        >
          <span className="inline-block text-[#2F6BFF] text-[13px] font-semibold tracking-[0.15em] uppercase mb-[24px]">
            Creative & Advertising Intelligence
          </span>
          
          <h1 className="text-[clamp(46px,5.5vw,76px)] font-semibold leading-[1.02] tracking-[-0.045em] text-white mb-[32px] max-w-[850px]">
            See Your Market Clearly.<br />
            Make Your Next Move Smarter.
          </h1>
          
          <p className="text-[clamp(17px,1.3vw,20px)] text-[#A7ADB8] mb-[32px] leading-[1.65] font-normal">
            Your competitors are constantly testing messages, offers and creative ideas. Maxmark helps you understand what is changing, what it means and what your brand should do next.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-[16px] mb-[24px]">
            <Link 
              to="/request-review" 
              className="bg-[#2F6BFF] hover:bg-[#1a54ff] text-white px-[32px] py-[20px] rounded-xl text-[13px] font-bold uppercase tracking-[0.1em] transition-all text-center"
            >
              Request an Intelligence Review
            </Link>
            <a 
              href="#the-guide"
              onClick={scrollToGuide}
              className="border border-[#242832] hover:border-white text-white px-[32px] py-[20px] rounded-xl text-[13px] font-bold uppercase tracking-[0.1em] transition-all text-center"
            >
              See How It Works
            </a>
          </div>

          <p className="text-[14px] text-[#A7ADB8] font-semibold tracking-wide">
            Monitor the market. Interpret the signals. Act with clarity.
          </p>
        </motion.div>
      </div>
    </section>
  );
}